//@ts-check
import helper from '../utils/fieldsHelper';
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {import("./types").SearchFieldOptions} options
 * @return {Array<import("./types").FormField>}
 */

var searchFields = function searchFields(state, options) {
  if (!state || !state.fields) return [];
  var result = []; // we need to iterate through all fields

  Object.keys(state.fields).forEach(function (id) {
    var field = state.fields[id];
    if (matchField(field, options)) result.push({
      id: field.id,
      type: field.type
    });
  });
  return result;
};
/**
 * @param {import("../logic/types").EcrionFormField} field
 * @param {import("./types").SearchFieldOptions} options
 */


var matchField = function matchField(field, options) {
  // exclude non-input fields from matching if the option say so
  if (options.inputFieldsOnly && !helper.isInputField(field.type)) return false;
  var typeMatched = options.type === 'unknown' || field.type === options.type;
  var propertiesMatched = true;
  options.matchProperties && Object.keys(options.matchProperties).forEach(function (property) {
    if (options.matchProperties[property] !== field[property]) propertiesMatched = false;
  }); // this field matched with the options

  var fieldMatched = typeMatched && propertiesMatched;
  if (fieldMatched && !options.inverse) return true;
  if (!fieldMatched && options.inverse) return true;
  return false;
};

export default searchFields;